/**
 * Created by wjm on 2022/1/13.
 */

export default {

    data () {
      return {
        submit_data:{}
      }
    },

    computed: {

    },
    props:['defaultValue','field','fieldArguments','optionData'],

    methods: {

      onChange (value) {
        const self = this;
        this.$emit('onChange', {field:self.field,value:value})
      },

    },
    created () {

    },
    mounted () {
      
      if(!this.defaultValue&&this.defaultValue!=0){
        this.child_defaultValue = this.inital_defaultValue;
      }else{
        this.child_defaultValue = this.defaultValue;
      }
    },

    watch: {
      defaultValue () {
        console.log('defaultValuechange',this.defaultValue);
        if(!this.defaultValue&&this.defaultValue!=0){
          this.child_defaultValue = this.inital_defaultValue;
        }else{
          this.child_defaultValue = this.defaultValue;
        }
      },
    }

}



// WEBPACK FOOTER //
// ./src/components/solely-fields/js/Common.js